// import Button1 from '@mui/material/Button';
// import { Delete } from '@material-ui/icons';

export const NewLine: React.FC<React.HTMLAttributes<HTMLDivElement>> = props => (
  <div style={{ flexBasis: '100%', height: 10, ...props.style }}>
    {props.children}
    </div>
);
